// Chat-store updates replace the messages array. Share one index across row
// selectors so a token flush does not scan the whole transcript for every row.
// Weak keys let closed chats and superseded streaming snapshots be collected.
const indexes = new WeakMap();

function indexMessages(messages) {
  let index = indexes.get(messages);
  if (index) return index;
  const byId = new Map();
  let lastUser = null;
  messages.forEach((message, position) => {
    if (!message) return;
    const entry = { message, position, previousUser: lastUser };
    for (const id of [message.id, message._id]) {
      // Preserve Array.find's first-match behavior, including duplicate IDs.
      if (id != null && id !== '' && !byId.has(id)) byId.set(id, entry);
    }
    if (message.role === 'user') lastUser = message;
  });
  index = { byId, lastUser };
  indexes.set(messages, index);
  return index;
}

export function findMessageById(messages, id) {
  if (!Array.isArray(messages) || id == null || id === '') return undefined;
  return indexMessages(messages).byId.get(id)?.message;
}

export function findIndexedParentUserMessage(messages, message) {
  const { byId, lastUser } = indexMessages(messages);
  const parent = message.parentMessageId && byId.get(message.parentMessageId)?.message;
  if (parent?.role === 'user') return parent;

  const byMessageId = byId.get(message.id);
  const byMongoId = byId.get(message._id);
  const entry = !byMessageId ? byMongoId : !byMongoId ? byMessageId
    : byMessageId.position <= byMongoId.position ? byMessageId : byMongoId;
  return entry ? entry.previousUser : lastUser;
}
